import { z } from 'zod';

import type { CreateCountryRequestViewModel } from '@/shared/api/generated';

/**
 * Schema do formulário de País (criar/editar). Validado por Zod (React Hook Form
 * + resolver).
 *
 * NÃO derivado de `createCountryRequestViewModelSchema` (gerado pelo Kubb): aquele
 * schema é exportado com o cast `as unknown as ToZod<CreateCountryRequestViewModel>`,
 * o que torna a shape do `ZodObject` uma ficção de tipo — qualquer `.pick()` /
 * `.extend()` sobre ele degrada o `z.infer` para `never`. Por isso o schema é
 * definido aqui diretamente, endurecendo `code` e `name` como obrigatórios (o
 * contrato gerado os tem como `nullish`), refletindo os campos `Código*`/`Nome*`
 * do protótipo `design/location.pen`.
 *
 * As mensagens de erro são resolvidas na UI a partir do namespace `location`.
 */
export const countryFormSchema = z.object({
  code: z.string().trim().min(1),
  name: z.string().trim().min(1),
  active: z.boolean(),
});

/**
 * Valores do formulário de País (create/edit).
 *
 * O tipo intersecta com uma asserção nula (no-op) que só permanece `unknown`
 * enquanto `code | name | active` continuarem existindo em
 * `CreateCountryRequestViewModel` — se um for renomeado/removido no contrato
 * gerado pelo Kubb, a asserção vira `never` e o `yarn type-check` quebra aqui.
 */
export type CountryFormValues = z.infer<typeof countryFormSchema> &
  ('code' | 'name' | 'active' extends keyof CreateCountryRequestViewModel ? unknown : never);
